import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconZip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconZip"><Path d="M6.5 3.5L3.50005 3.50001L3.5 20.5H20.5V3.5H17.5M9.5 3.5H14.5M9.5 7.5H14.5M9.75 11.5H14.25V14.25C14.25 15.4926 13.2426 16.5 12 16.5C10.7574 16.5 9.75 15.4926 9.75 14.25V11.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconZip;
